import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Order } from '../Order'

export interface ICreateOrder extends IAction<Order, CreateOrderArgs> {}

/**
 * Args for the generic createOrder path. Mirrors BaseResolver's CRUD contract (an arbitrary order
 * `input`); the resolver keeps its explicit JSON `input` arg.
 */
@InputType()
export class CreateOrderArgs extends ActionArgs {
  /** The order to create. */
  @Field(() => GraphQLJSON, { nullable: false })
  input: Order
}
